export const baseUrl = "https://adminecosystem.uptimiseit.com/";
